import { CheckoutState } from '../../state';
import { isEventbriteTLDInDevOrQAEnv } from '../../utils/browser';
import { isEventbriteTLD } from '../app';

export const TLDSupportsGooglePay = (state: CheckoutState) =>
    isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv();
